import { Button } from "@devhop/ui";
import { PlusIcon } from "lucide-react";

type MemberTiersToolbarProps = {
  onCreate: () => void;
  canCreate?: boolean;
};

export function MemberTiersToolbar({
  onCreate,
  canCreate = true,
}: MemberTiersToolbarProps) {
  return (
    <div className="mb-2 flex flex-col gap-4">
      <div className="flex flex-wrap items-center justify-between space-y-2">
        <div>
          <h2 className="font-bold text-2xl tracking-tight">ລະດັບສະມາຊິກ</h2>
          <p className="text-muted-foreground">ຈັດການລະດັບສະມາຊິກ ສຳລັບລູກຄ້າ</p>
        </div>
        {canCreate && (
          <Button onClick={onCreate}>
            <PlusIcon className="h-4 w-4" />
            ສ້າງລະດັບສະມາຊິກ
          </Button>
        )}
      </div>
    </div>
  );
}
